import React, { FC, Fragment } from 'react'

import { useStyles } from './styles'

interface Props {
    hasTitle?: boolean
    children?: React.ReactNode
}

export const StackLayout: FC<Props> = ({
    children,
    hasTitle = true
}) => {
    const styles = useStyles()

    return (
        <Fragment>
            {
                React.Children.map(children, (child, index) => {
                    const Component = index === 0 && !hasTitle
                        ? styles.itemWithoutTitle
                        : styles.item

                    return (
                        <Component>
                            {child}
                        </Component>
                    )
                })
            }
        </Fragment>
    )
}